<template>
	<div>
		<div>
			<div class="float-right">
				<button @click="save" class="btn btn-primary mr-2">{{ $t('save') }}</button>
				<button @click="cancel" class="btn btn-secondary">{{ $t('cancel') }}</button>
			</div>
		</div>
		<h1>{{ $t('procedure') }}</h1>
		<div v-if="saved">
			<div class="alert alert-success mt-8">{{ $t('form-saved') }}</div>
		</div>

		<div>
			<b-tabs content-class="mt-3">
				<b-tab title="Settings" active >
					<div class="row">
						<template>
							<div class="col">
								<fieldset >
									<legend>{{ $t('settings') }}</legend>
									<div class="form-group">
										<label for="dataelement-caption">{{ $t('caption') }}</label>
										<input id="dataelement-caption" name="dataelementcaption" v-model="item.caption" class="form-control"  :placeholder="$t('caption')" required>
									</div>
									<div class="form-group">
										<label for="dataelement-caption">{{ $t('sections') }}</label>
										<div class="list-group mb-2">
											<div v-for="sectionid in item.sections" :key="sectionid" class="list-group-item">
												<button @click="removeSection(sectionid)" class="btn btn-light btn-sm float-right"><b-icon-trash></b-icon-trash></button>
												{{ sectionoptions[sectionid] }}
											</div>
										</div>
										<select class="form-control" @change="addSection($event)">
											<option value="0">{{$t('add')}}</option>
											<template  v-for="(name, id) in sectionoptions">
											<option v-if="item.sections.indexOf(id) == -1" :key="id" :value="id">{{name}}</option>
											</template>
										</select>
									</div>
									<div class="form-group">
										<label for="dataelement-maxoccurs">{{ $t('max-per-treatment-session') }}</label>
										<input id="dataelement-maxoccurs" name="dataelementmaxoccurs" v-model="item.maxoccurs" class="form-control"  :placeholder="$t('max-per-treatment-session')" required>
									</div>
									<div class="form-group">
										<label for="dataelement-markingset">{{ $t('marking-set') }}</label>
										<select class="form-control" name="dataelementmarkingset" v-model="item.markingset">
											<!-- needs pulling in? -->
											<option value="">None</option>
											<option v-for="(caption, key) in markingsets" :key="key" :value="key">{{$t(caption)}}</option>
										</select>
									</div>
									<div class="form-group">
										<label for="dataelement-information">{{ $t('information') }}</label>
										<vue-editor id="dataelement-information" name="dataelementinformation" v-model="item.information" class="bg-white"></vue-editor>
									</div>
									<div class="form-group">
										<label for="dataelement-validation-information">{{ $t('validation-information') }}</label>
										<vue-editor id="dataelement-validation-information" name="dataelementvalidationinformation" v-model="item.validationinformation" class="bg-white"></vue-editor>
									</div>
								</fieldset>
							</div>
							<div class="col">
								<fieldset >
									<div class="form-group">
										<label for="dataelement-keywords">{{ $t('keywords') }}</label>
										<textarea-autosize id="dataelement-keywords" name="dataelementkeywords" v-model="item.keywords" class="form-control"></textarea-autosize>
									</div>
									<div class="form-group">
										<label for="dataelement-validation">{{ $t('validation') }}</label>
										<textarea-autosize id="dataelement-validation" name="dataelementvalidation" v-model="item.validation" class="form-control"></textarea-autosize>
									</div>

								</fieldset>

								<template v-if="(Object.keys(reporting.procedures).length > 0 || Object.keys(reporting.formelements).length > 0)">
									<h2>{{ $t('reported-in') }}</h2>
									<div class="list-group no-border">
										<template v-for="(procedure, pindex) in reporting.procedures">
											<div v-for="(item, rindex) in procedure" :key="pindex + '_' + rindex" class="list-group-item p-0">
												<router-link v-if="('reportdataelement_id' in item && item['reportdataelement_id'])" :to="'/settings/reports/dataelements/edit/' +item.reportdataelement_id" class="list-group-item">
													{{item.caption}}
													({{item.name}})
												</router-link>
												<div v-else class="list-group-item">
													{{item.caption}}
													({{item.name}})
												</div>
											</div>

										</template>
										<template v-for="(formelement, findex) in reporting.formelements">
											<div v-for="(item, rindex) in formelement" :key="findex + '_' + rindex" class="list-group-item p-0">
												<router-link v-if="('reportdataelement_id' in item && item['reportdataelement_id'])" :to="'/settings/reports/dataelements/edit/' +item.reportdataelement_id" class="list-group-item">
													{{item.caption}}
													({{item.name}})
												</router-link>
												<div v-else class="list-group-item">
													{{item.caption}}
													({{item.name}})
												</div>
											</div>

										</template>
									</div>
								</template>

							</div>

						</template>
					</div>
				</b-tab>
				<b-tab title="Form Elements" lazy >
					<draggable
						v-model="item.formelements"
						handle=".card-header"
						ghost-class="vuedraggable-ghost"
					>
						<div v-for="(formelement, formelementIndex) in item.formelements" :key="formelementIndex" class="panel panel-default">

							<div
								class="card mb-3"
								:sort="true"
							>

								<div class="card-header">
									<a class="btn btn-light btn-xs mr-1"
									data-toggle="tooltip" data-placement="top" :title="$t('drag-to-reorder')"
									><b-icon icon="arrows-move"></b-icon></a>
									<template v-if="formelement.caption">
										{{formelement.caption}} ({{formelement.name}})
									</template>
									<template v-else>
										{{formelement.name}}
									</template>
									<template v-if="formelement.formelementtype_id in fieldtypes">
										- {{$t(fieldtypes[formelement.formelementtype_id])}}
									</template>

									<div class="float-right">

										<a class="btn btn-danger btn-sm"
										@click="removePage(formelement,item)"><b-icon icon="trash" width="1em" height="1em"></b-icon> {{ $t('remove') }}
										</a>

										<a class="btn btn-secondary btn-sm ml-3"
											data-toggle="tooltip" data-placement="top"
											@click="togglePage(formelement)">
											<b-icon :icon="`caret-${formelement.show ? 'up' : 'down'}-fill`"></b-icon>
										</a>

									</div>

								</div>

								<div class="card-body" v-show="formelement.show">

									<FormElement
										:formelement="formelement"
										:fieldtypes="fieldtypes"
										:reporting="reporting"
									/>

									<draggable
											v-if="formelement.formelementtype_id==13 || formelement.formelementtype_id==14"
											v-model="formelement.formelements"
											handle=".card-header"
											ghost-class="vuedraggable-ghost"
										>
										<div v-for="(innerElement, innerPageIndex) in formelement.formelements" :key="innerPageIndex" class="panel panel-default">

											<div
												class="card mb-3"
												:sort="true"
											>

												<div class="card-header">
													<a class="btn btn-light btn-xs mr-1"
													data-toggle="tooltip" data-placement="top" :title="$t('drag-to-reorder')"
													><b-icon icon="arrows-move"></b-icon></a>
													<template v-if="innerElement.caption">
														{{innerElement.caption}} ({{innerElement.name}})
													</template>
													<template v-else>
														{{innerElement.name}}
													</template>
													<template v-if="innerElement.formelementtype_id in fieldtypes">
														- {{$t(fieldtypes[innerElement.formelementtype_id])}}
													</template>

													<div class="float-right">

														<a class="btn btn-danger btn-sm"
														@click="removePage(innerElement, formelement)"><b-icon icon="trash" width="1em" height="1em"></b-icon> {{ $t('remove') }}
														</a>

														<a class="btn btn-secondary btn-sm ml-3"
															data-toggle="tooltip" data-placement="top" title="Toggle Page"
															@click="togglePage(innerElement)">
															<b-icon :icon="`caret-${innerElement.show ? 'up' : 'down'}-fill`"></b-icon>
														</a>

													</div>

												</div>

												<div class="card-body" v-show="innerElement.show">

													<FormElement
														:formelement="innerElement"
														:fieldtypes="fieldtypes"
														:reporting="reporting"
													/>

												</div>
											</div>
										</div>
										<div class="float-right">
											<button @click="addInnerFormElement(formelement)" class="btn btn-light mr-2">+ {{ $t('add-new-form-element') }}</button>
										</div>
									</draggable>
								</div>
							</div>
						</div>
					</draggable>
					<div class="float-right">
						<button @click="addFormElement" class="btn btn-secondary mb-4">+ {{ $t('add-new-form-element') }}</button>
					</div>
				</b-tab>
			</b-tabs>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import { VueEditor } from "vue2-editor";
import FormElement from 'src/components/InterfaceEditor/FormElement';
export default {

	components: {
		draggable,
		VueEditor,
		FormElement
	},
	props: ['field', 'readonly'],
	data() {
		return {
			saved: false,
			item: {
				id: 'new' ,
				name: '' ,
				caption: '' ,
				position: 0,
				maxoccurs: 100,
				markingset: 'default',
				validation: '',
				validationinformation: '',
				information: '',
				keywords: '',
				publishedstate: 1 ,
				sections: [],
				formelements: []
			},
			sectionoptions: {},
			reporting: {
				procedures: {} ,
				formelements: {}
			},
			fieldtypes: {},
			markingsets: {},
		}
	},
	mounted() {
		this.getSectionOptions();
		this.getSettings();
	},
	methods: {
		getSettings(){
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/getprocedureoptions`)
			.then((json) => {
				if(json.status == 'SUCCESS'){
					this.markingsets = json.markingsets;
					this.fieldtypes = json.fieldtypes;
					if(this.$route.params.itemid){
						this.getItem();
					}
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		} ,
		getItem(){
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/procedure/${this.$route.params.itemid}`, {
				data: {
				}
			})
			.then((json) => {
				if(json.status == 'SUCCESS'){
					json.result.formelements.forEach(formelement => {
						formelement.show = false;
						if (formelement.formelements) {
							formelement.formelements.forEach(formelementinner => {
								formelementinner.show = false;
							});
						}
					});
					this.item = json.result;
					this.getReporting();
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getSectionOptions(){
			this.sectionoptions = {};
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/sections`, {
				data: {
				}
			})
			.then((json) => {
				if(json.status == 'SUCCESS'){
					json.results.forEach(section => {
						this.sectionoptions[section.id] = section.name
					});
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getReporting(){
			var data = {
				"procedure_id": [
					this.$route.params.itemid
				]
			}
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/mapreporting`, {
				data ,
				method: 'post'
			})
			.then((json) => {
				if(json.status == 'SUCCESS'){
					this.reporting.procedures = json.procedures;
					this.reporting.formelements = json.formelements;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		save() {
			// If has no ID coming from Section as a new procedure we get an undefined on the save so need to assign an ID? or something to create if no ID assigned
			return this.$cfetch(`${this.$settings.APIBaseURL}/procedures/procedure/${this.item.id}`, {
				method: "post",
				data: {
					save: true ,
					procedure: this.item
				}
			})
			.then(json => {
				if (json.status === 'SUCCESS') {
					json.result.formelements.forEach(formelement => {
						formelement.show = false;
					});
					this.item = json.result;
					this.saved = true;
					// bad ux IMHO when this doesn't go away as no feedback on subsequent saves
					setTimeout(() => {
						this.saved = false;
					}, 5000);
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
        },
        cancel() {
			this.$router.go(-1);
        },
		togglePage(formelement) {
			formelement.show = !formelement.show;
		},
		removePage: function(formelement,item){
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("remove-element-q"),
				content: this.$t('remove-element-{n}q', {'n': formelement.caption}),
				confirmBtnText: this.$t('yes'),
				cancelBtnText: this.$t('no'),
				confirmCallBack() {
					item.formelements.splice(item.formelements.indexOf(formelement), 1);
				},
				cancelCallBack() {
				}
			});
		},
		addFormElement() {
			this.item.formelements.push({
				name: null,
				caption: null,
				formelementtype_id: null,
				default: null,
				id: null,
				dependencies: null,
				attributes: null,
				changeEvent: null,
				information: null,
				options: [],
				parent_id: null,
				position: "0",
				publishedstate: "1",
				setControlState: null,
				validation: null,
				show: "true",
				formelements: []
			});
			this.$forceUpdate();
		},
		addInnerFormElement(formelement){
			formelement.formelements.push({
				name: null,
				caption: null,
				formelementtype_id: null,
				default: null,
				id: null,
				dependencies: null,
				attributes: null,
				changeEvent: null,
				information: null,
				options: [],
				parent_id: null,
				position: "0",
				publishedstate: "1",
				setControlState: null,
				validation: null,
				show: "true",
			});
			this.$forceUpdate();
		},
		addSection(event){
			this.item.sections.push(event.target.value);
			event.target.value = 0;
		},
		removeSection(sectionid){
			this.item.sections.splice(this.item.sections.indexOf(sectionid), 1);
		}
	},
	computed: {

	}
};

</script>
